import DishOptions from "../dishOptions/DishOptions";
import PropTypes from "prop-types";
import './DishInfo.scss';

const DishInfo = ({dish}) => {
    const {imageUrl, description, options} = dish;
    return (
        <div className="dish-info">
            {imageUrl && <img src={imageUrl} alt="dish"/>}
            <div>
                <p>{description}</p>
                <DishOptions options={options}/>
            </div>
        </div>
    );
}

DishInfo.propTypes = {
    dish: PropTypes.object.isRequired
};

export default DishInfo;